interface LogoProps {
  className?: string;
  showTagline?: boolean;
}

export function Logo({ className = "h-10 w-auto", showTagline = true }: LogoProps) {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {/* Digital Bolt Icon - Scaled to span two lines */}
      <svg
        width="40" height="40"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-auto md:h-12"
      >
        {/* Main Bolt Body */}
        <path
          d="M20 4L14 14H20L10 28L14 18H8L18 4Z"
          fill="url(#bolt-gradient)"
          stroke="url(#bolt-gradient)"
          strokeWidth="1"
          strokeLinejoin="round"
        />
        {/* The 'Byte' Pixel */}
        <rect x="22" y="4" width="4" height="4" rx="1.5" fill="#8B5CF6" className="animate-pulse" />

        <defs>
          <linearGradient id="bolt-gradient" x1="8" y1="4" x2="20" y2="28" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3B82F6" />
            <stop offset="1" stopColor="#6366F1" />
          </linearGradient>
        </defs>
      </svg>

      {/* Text Part */}
      <div className="flex flex-col justify-center leading-none">
        <div className="logo-text text-xl md:text-2xl tracking-tighter flex items-baseline">
          <span className="text-foreground">Accelerate</span>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">Byte</span>
        </div>
        {showTagline && (
          <span className="text-[10px] md:text-[11px] font-medium text-muted-foreground tracking-[0.1em] mt-1">
            You think. We build.
          </span>
        )}
      </div>
    </div>
  );
}
